<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { VueEditor, Quill } from 'vue2-editor'

export default
{
    name: 'mv-contact-person-form',

    components: { VueEditor },

    computed:
    {
        ...mapGetters({
            locale: 'generalCurrentLocale',
        }),
    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },
    },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    data()
    {
        return {}
    },
}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">

        <div class="form-group row">
            <label for="order" class="col-md-4 control-label">
                {{ $t('MENUS.ORDER') }}
            </label>
            <div class="col-md-6">
                <input type="number" class="form-control" v-model="model.order" >
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.NAME') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.name">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.GROUP') }}
            </label>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.group">
                </div>
            </div>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.group_en" >
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.POSITION') }}
            </label>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.position">
                </div>
            </div>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.position_en" >
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.EMAIL') }}
            </label>
            <div class="col-md-6">
                <input type="email" class="form-control" v-model="model.email">
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-4 control-label">
                {{ $t('GENERAL.PHONE') }}
            </label>
            <div class="col-md-6">
                <input type="tel" class="form-control" v-model="model.phone">
            </div>
        </div>

        <vue-editor
            v-if="locale == 'hu'"
            :editorOptions="editorSettings"
            v-model="model.description">
            </vue-editor>

        <vue-editor
            v-if="locale == 'en'"
            :editorOptions="editorSettings"
            v-model="model.description_en">
            </vue-editor>

    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/ContactPersonForm.vue